import CONFIG from '@/configs/config'
import { Get, Post, Delete } from '@/utils/RequestService'

var apiUrl = CONFIG.API_URL
var service = {
  tranHistory: (page, params) => Get(`${apiUrl}users/trans-history/${page}/10`, params),
  getUser: () => Get(`${apiUrl}users`),
  getUserConfig: (symbol) => Get(`${apiUrl}users/buy-config?symbol=${symbol}`),
  uploadUserKyc: (data) => Post(`${apiUrl}users/kyc/upload`, data),
  getUserKyc: () => Get(`${apiUrl}users/kyc/detail`),
  getUserMatrix: (code) => Get(`${apiUrl}users/matrix-info/${code || ''}`),
  changeUserMatrix: (data) => Post(`${apiUrl}users/change-matrix`, data),
  getTreeData: () => Get(`${apiUrl}users/aff-tree`),
  getAffMember: () => Get(`${apiUrl}users/aff-member`),
  buy: (data) => Post(`${apiUrl}users/buy`, data),
  getAffMemberByLevel: (level) => Get(`${apiUrl}users/aff-member/${level}`),
  getUserOverview: () => Get(`${apiUrl}users/user-overview`),
  getUserMaxout: () => Get(`${apiUrl}users/maxout`),
  getUserStaticalSale: () => Get(`${apiUrl}users/statical-sale`),
  getUserStaticalRole: () => Get(`${apiUrl}users/statical-role`),
  getUserStats: (params) => Get(`${apiUrl}users/total-sale/${params.affCode}/${params.fromTime}/${params.toTime}`),
  changePassword: (data) => Post(`${apiUrl}users/change-password`, data),
  getTotalPps: () => Get(`${apiUrl}users/power-mining`),
  getEstimateBuy: (data) => Post(`${apiUrl}users/estimate-buy`, data),
  request2FA: () => Get(`${apiUrl}users/totp`),
  enable2FA: (data) => Post(`${apiUrl}users/totp`, data),
  disable2FA: (data) => Delete(`${apiUrl}users/totp`, data),
  sendEmailCode: () => Get(`${apiUrl}users/withdraw-otp`)
}

export default service
